import { baiduMapJumpOtherApp, addPvNew } from '@/pages/micro-detail/utils/index';
import { isBaiduMap } from '../../../utils';
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isBaiduMap: isBaiduMap(),
      defaultImg: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/default-feed.png'
    };
  },
  mounted() {
    addPvNew(['MCDfeed.BMapPOI.card.NewMedia.new.hotnew.show'], {});
  },
  methods: {
    handleHotInfo() {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      const {
        scheme_url = '',
        url: fallbackUrl = ''
      } = this.info || {};
      const jumpParam = {
        scheme: scheme_url,
        fallbackUrl,
        pvHead: ['MCDfeed.BMapPOI.card.NewMedia.new.hotnew.click'],
        // 跳转成功埋点
        pvParam: {
          callup_type: 1
        },
        // 跳转失败埋点
        failPvParam: {
          callup_type: 2
        },
        isAddSuccAndFail: true,
        cb: () => {
          // 调起
        }
      };
      baiduMapJumpOtherApp(jumpParam);
      return;
    }
  },
  computed: {}
};